__turbopack_context__.v({
  "buttonWrapper": "TeamsUpsell-module__NokJCq__buttonWrapper",
  "root": "TeamsUpsell-module__NokJCq__root",
  "textWrapper": "TeamsUpsell-module__NokJCq__textWrapper",
});
